import { gql } from "@grandvisionhq/graphql";
const SIGNUP_PROMOTION = gql`
  mutation SignupPromotion($signupPromotionInput: SignupPromotionInput!) {
    signupPromotion(signupPromotionInput: $signupPromotionInput) {
      campaignId
      success
      errorMessage
    }
  }
`;
export {
  SIGNUP_PROMOTION
};
//# sourceMappingURL=signup-promotion.js.map
